import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingVideoEnhancerConfig } from '@/data/landingConfig/landingVideoEnhancerConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_VideoEnhancer } from './schemaObject';

interface Props {}
const VideoEnhancer: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_VideoEnhancer} />
			<VideoLandingTemplate
				data={landingVideoEnhancerConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoEnhancer()}
			/>
		</>
	);
};

export default VideoEnhancer;
